import { useContext } from 'react';
import { ExerciseTranslationsContext } from '../contexts/ExerciseTranslationsContext';

function ServiceNotAvailable() {
  const translations = useContext(ExerciseTranslationsContext);

  return (
    <div className="exercise-container" data-testid="service-not-available">
      <div className="content">
        <img src={process.env.PUBLIC_URL + '/images/p_logo.svg'} alt="P logo" className="logo" />
        <div className="body">
          <h1 className="title">{translations.serviceNotAvailable.title}</h1>
          <div>
            <p>{translations.serviceNotAvailable.p1}</p>
            <p>{translations.serviceNotAvailable.p2}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceNotAvailable;
